import React from "react";
import { CardElement } from '@stripe/react-stripe-js';

class CreditCardForm extends React.Component {

  constructor(props){
    super();
    
    this.state = {
      key: 1,
    }
  };

  componentDidMount() {
    if (this.props.card && !this.props.card.name_on_card && this.props.name_on_card){
      this.props.onChangeCardInput({ target: { name: 'name_on_card', value: this.props.name_on_card } })
    };
  };

  componentDidUpdate(){
    if (this.props.incrementCardElementKey){
      this.setState({key: this.state.key += 1}, () => {
        this.props.cardElementKeyIncremented()
      });
    };
  };

  render(){
    if(this.props.stackedForm){
      return this.stackedCardForm();
    } else {
      return (
        <div className={this.props.additionalClasses ? 'CreditCardForm PaymentMethod ' + this.props.additionalClasses : 'CreditCardForm PaymentMethod'} >
          <div className='row card-details-wrapper'>
            {this.renderNameOnCard()}
            <div className={this.props.cardInputWidth ? this.props.cardInputWidth + " card-element-wrapper" : "col-md-7 card-element-wrapper"}>
              <div className="form-group">
                <label>{`${I18n.t('card_details')}`} </label>
                <div className={this.props.hasClassErrors && this.props.hasClassErrors('card_validation_error') ? "has-errors form-control" : "form-control"}>
                  <CardElement key={this.state.key}/>  
                </div>
                  {this.props.renderFieldErrors ? this.props.renderFieldErrors('card_validation_error') : null}
              </div>
            </div>
          </div>
          {this.props.displayCardResetButton ? <button type="button" className="no-ladda btn  btn-primary btn-modal-footer btn-btn-primary btn-reset_button" onClick={this.resetCardElement}>{I18n.t('reset_card_details')}</button> : null}
        </div>
      );
    };
  };

  renderNameOnCard(){
    return(
      <div className={this.props.nameOnCardInputWidth ? this.props.nameOnCardInputWidth + ' card-name ' : 'col-sm-5 card-name '}>
        <div className={'form-group '} style={{marginBottom: this.props.stacked ? '15px' : '0px'}}>
          <label>{I18n.t('name_on_card')}*</label>
          <input type='text' data-id={this.props.id} className={this.props.hasClassErrors && this.props.hasClassErrors('name_on_card_error') ? 'form-control has-errors' : 'form-control'} name='name_on_card' value={this.props.card && this.props.card.name_on_card ? this.props.card.name_on_card : ''} onChange={this.props.onChangeCardInput} disabled={this.props.disableNameOnCard ? true : false} pattern="\p{L}" placeholder={I18n.t('card_name')} />
          {this.props.renderFieldErrors ? this.props.renderFieldErrors('name_on_card_error') : null}
          <div style={{margin: '5px 0 0 0'}}>
            <input type='checkbox' 
                    name='save_card' 
                    style={{position: 'relative', top: '1px'}}
                    onChange={this.props.onChangeCardInput} 
                    disabled={this.props.lockSave ? true : false} 
                    checked={this.props.card && this.props.card.save_card ? this.props.card.save_card : false} 
                    /> <span>{I18n.t('save_card')}</span>
          </div> 
        </div>
      </div>
    );
  };

  stackedCardForm = () => {
    return(
      <div className={this.props.additionalClasses ? 'CreditCardForm PaymentMethod ' + this.props.additionalClasses : 'CreditCardForm PaymentMethod'} >
        <div className='card-details-wrapper'>
          <div className="row">
            <div className="card-name col-sm-12">
              <div className="form-group">
                <label>{I18n.t('name_on_card')}*</label>
                <input type='text' data-id={this.props.id} className={this.props.hasClassErrors && this.props.hasClassErrors('name_on_card_error') ? 'form-control has-errors' : 'form-control'} name='name_on_card' value={this.props.card && this.props.card.name_on_card ? this.props.card.name_on_card : ''} onChange={this.props.onChangeCardInput} disabled={this.props.disableNameOnCard ? true : false} pattern="\p{L}" placeholder={I18n.t('card_name')} />
                {this.props.renderFieldErrors ? this.props.renderFieldErrors('name_on_card_error') : null}
                <div style={{ marginTop: '5px' }}>
                  <input type='checkbox'
                    name='save_card'
                    style={{ position: 'relative', top: '1px' }}
                    onChange={this.props.onChangeCardInput}
                    disabled={this.props.lockSave ? true : false}
                    checked={this.props.card && this.props.card.save_card ? this.props.card.save_card : false}
                  /> <span>{I18n.t('save_card')}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 card-element-wrapper">
              <div className="form-group">
                <label>{`${I18n.t('card_details')}`} </label>
                <div className={this.props.hasClassErrors && this.props.hasClassErrors('card_validation_error') ? "has-errors form-control" : "form-control"}>
                  <CardElement key={this.state.key} />
                </div>
                {this.props.renderFieldErrors ? this.props.renderFieldErrors('card_validation_error') : null}
              </div>
            </div>         
          </div>
        </div>
      </div>
    );
  };

  resetCardElement = () => {
    this.setState({key: this.state.key += 1}, () => {
      this.props.onResetCardElement ? this.props.onResetCardElement() : null;
    });
  };

};

export default CreditCardForm